// extracted by mini-css-extract-plugin
export default {"itemStyles":"CasinoProviderSelector_itemStyles__ExDsY","mainItem":"CasinoProviderSelector_mainItem__A8bJc"};